<template>
  <BaseModal
    v-if="open"
    :close-button-visible="false"
    overlay-class="other_modals net_prob"
  >
    <div class="content">
      <div :id="imageTeleportElId"></div>

      <h3 class="title">
        {{ $_translations.value.modal_offline_title_pt1 }}<br>
        {{ $_translations.value.modal_offline_title_pt2 }}
      </h3>

      <p>{{ $_translations.value.modal_offline_description }}</p>
    </div>
  </BaseModal>

  <Teleport v-bind="imageTeleportProps">
    <BaseImage
      v-show="open"
      src="/static/images/other/network_icon.svg"
      image-class="image_404"
      alt="Network Problem"
    />
  </Teleport>
</template>

<script setup>
import { ref, watch } from 'vue';
import BaseModal from '@/components/modal/BaseModal.vue';
import BaseImage from '@/components/image/BaseImage.vue';

const imageTeleportElId = 'offline_modal_main_img';

const props = defineProps({
  open: {
    type: Boolean,
    default: false,
  },
});

const imageTeleportProps = ref({});

watch(
  () => props.open,
  (curValue) => {
    if (curValue) {
      imageTeleportProps.value = { to: `#${ imageTeleportElId }` };
    } else {
      imageTeleportProps.value = { disabled: true };
    }
  },
  { immediate: true },
);
</script>
